<template>
  <div class="emergency-response">
    <Card :dis-hover="true" :bordered="true">
      <template #extra>
        <Icon v-if="$route" type="md-refresh" :size="22"
              @click="goRefresh"
              style="cursor: pointer;margin-right: 10px"
        />
        <Icon v-if="$route" type="md-close" :size="22"
              @click="goBack"
              style="cursor: pointer"
        />
      </template>
      <el-descriptions class="margin-top" title="事件信息" size="medium" :column="2" border
                       :labelStyle="{'text-align': 'center','width':'15%','color':'#555'}">
        <el-descriptions-item label="事件标题" :span="2">
          {{ eInfo.eventTitle }}
        </el-descriptions-item>
        <el-descriptions-item label="事发地点">
          <p @click="mapShow">{{ eInfo.incidentArea }}</p>
        </el-descriptions-item>
        <el-descriptions-item label="事件类型">
          {{ eInfo.eventTypeName }}
        </el-descriptions-item>
        <el-descriptions-item label="事件描述" :span="2">
          {{ eInfo.eventDescription }}
          <!--          （原因、路产损失情况、交通状况、人员伤亡情况）-->
        </el-descriptions-item>
        <el-descriptions-item label="上报人">
          {{ eInfo.reportPerson }}
        </el-descriptions-item>
        <el-descriptions-item label="上报电话">
          {{ eInfo.reportPhone }}
        </el-descriptions-item>
        <el-descriptions-item label="事件照片">
          <div v-if="eInfo.eventImgPath && eInfo.eventImgPath.length > 0"
               style="display: flex;flex-direction: row;flex-wrap: wrap;align-content: flex-start;">
            <!--            <img v-for="(item,index) in eInfo.eventImgPath" :src="item.url" :key="index" width="200" height="200"-->
            <!--                 style="margin-right: 10px" @click="previewPic(item)"/>-->
            <el-image v-for="(item,index) in eInfo.eventImgPath" :key="index"
                      style="width: 200px; height: 200px;margin-top: 10px;margin-right: 10px;"
                      :src="item"
                      :preview-src-list="eInfo.eventImgPath">
            </el-image>
          </div>
          <div v-else>无</div>
        </el-descriptions-item>
      </el-descriptions>
    </Card>
    <Modal v-model="mapModalIsShow" footer-hide :width="80">
      <div class="map" id="map" v-loading="mapLoading"></div>
    </Modal>
    <Card v-if="eInfo.isDrill!=='0'" :dis-hover="true" style="margin-top: 10px">
      <el-steps :active="curStep" align-center finish-status="success">
        <!--        <el-step title="开始" description="开始">-->
        <!--        </el-step>-->
        <el-step v-for="(item,index) in stepList" :key="index" @click.native="showModule(item, index)">
          <template #title>
            <div style="font-size: 16px">
              {{ item.disposalProcess.operate !== null ? item.disposalProcess.operate : item.disposalProcess.name }}
            </div>
          </template>
          <template #description>
            <div>{{ item.disposalProcess.name }}</div>
            <div>{{ item.jumpTime === null ? '' : $moment(item.jumpTime).format('YYYY-MM-DD HH:mm') }}</div>
          </template>
        </el-step>
      </el-steps>
      <Card v-if="curComponent !== 0&&curComponent !== 1" :bordered="false" :dis-hover="true"
            :title="compConfigList[curComponent].label" style="margin-top: 16px">
        <el-image src="https://dzgllw.com/uploadFile/quxian.png"
                  :preview-src-list="['https://dzgllw.com/uploadFile/quxian.png']"
                  style="width: 30%;height: 200px"></el-image>
        <component style="display: inline-block;vertical-align: top;width: 60%" :is="compConfigList[curComponent].cName"
                   :eventInfo="eInfo"
                   :stepInfo="curStepInfo"
                   :preStep="preStep"
                   @refreshStep="refreshStep"/>
      </Card>
    </Card>
    <Modal
      v-model="showPic"
      title="预览"
      :footer-hide="true"
    >
      <img alt="" :src="selectPic.url" width="100%" height="100%"/>
    </Modal>
    <Modal v-model="monitorModal" title="实时监控" :width="50" footer-hide @on-visible-change="visibleChange">
      <div class="content">
        <JessibucaVideo id="jessibuca" ref="jessibuca" class="video"
                        :video-url="`${$videoUrl}/rtp/${currentMonitor['deviceId']}_${currentMonitor['deviceId']}.live.flv`"/>
      </div>
    </Modal>
  </div>
</template>

<script>
import {defineAsyncComponent} from 'vue'
import JessibucaVideo from '@/views/Screen/components/Video/JessibucaVideo.vue'

export default {
  name: "emergencyResponse",
  components: {
    JessibucaVideo
  },
  props: {
    eventInfo: {
      type: Object,
      default: () => {
      }
    }
  },
  data() {
    return {
      mapModalIsShow: false,
      mapLoading: false,
      monitorModal: false,
      currentMonitor: {},
      showPic: false,
      selectPic: {},
      eInfo: {},
      stepList: [],
      curStep: 0,
      curStepInfo: '',
      preStep: '',
      compConfigList: [
        {
          label: '接警核实',
          name: '值班人员',
          cName: null
        },
        {
          label: '审核',
          name: '值班领导',
          cName: null
        },
        {
          label: '判定事件等级',
          name: '中心应急领导小组',
          cName: defineAsyncComponent(() => import('@/views/emergencyResponse/components/eventLevel/eventLevel.vue'))
        },
        {
          label: '制定先期处置方案',
          name: '县区中心应急领导小组',
          cName: defineAsyncComponent(() => import('@/views/emergencyResponse/components/disposalPlan/disposalPlan.vue'))
        },
        {
          label: '专家会商',
          name: '市中心应急领导小组',
          cName: defineAsyncComponent(() => import('@/views/emergencyResponse/components/expertConsultation/expertConsultation.vue'))
        },
        {
          label: '调配资源',
          name: '县区中心应急领导小组',
          cName: defineAsyncComponent(() => import('@/views/emergencyResponse/components/matchingPlan/matchingPlan.vue'))
        },
        {
          label: '支援物资',
          name: '市中心应急领导小组',
          cName: defineAsyncComponent(() => import('@/views/emergencyResponse/components/centralScheduling/centralScheduling.vue'))
        },
        {
          label: '现场处置',
          name: '现场处置',
          cName: defineAsyncComponent(() => import('@/views/emergencyResponse/components/siteDisposal/siteDisposal.vue'))
        },
        {
          label: '评估验收',
          name: '评估验收',
          cName: defineAsyncComponent(() => import('@/views/emergencyResponse/components/eventEvaluation/eventEvaluation.vue'))
        },
        // {
        //   label: '验收',
        //   name: '验收',
        //   cName: defineAsyncComponent(() => import('@/views/emergencyResponse/components/checkAccept/checkAccept.vue'))
        // },
        {
          label: '响应终止',
          name: '响应终止',
          cName: null
        }
      ], //动态加载表单配置
      curComponent: 0,
      map: null,
      monitorList: [],
    }
  },
  mounted() {
    this.getEventDetails()
    this.getAllMonitor()
  },
  methods: {
    mapShow() {
      this.mapModalIsShow = true
    },
    visibleChange(flag) {
      if (flag) {
        this.playVideo()
      } else {
        this.close()
      }
    },
    // 根据id获取事件信息
    getEventDetails() {
      let id = this.$route.query.id
      this.$http.get(`/api/messageReceptions/${id}`).then(res => {
        if (res.status === 200) {
          this.eInfo = res.data
          this.formatImgPath()
          this.getLinks()
          this.$nextTick(() => {
            this.initMap()
          })
        }
      })
    },
    initMap() {
      this.map = new BMapGL.Map("map");          // 创建地图实例
      let point = new BMapGL.Point(parseFloat(this.eInfo.longitude), parseFloat(this.eInfo.latitude));  // 创建点坐标
      this.map.centerAndZoom(point, 18);
      this.map.enableScrollWheelZoom(true);     //开启鼠标滚轮缩放
      this.showPoint()
    },
    // 获取所有监控
    getAllMonitor() {
      this.mapLoading = true
      this.$http.post(`/api/point/monitorPoint?page=1&size=99999`, {}).then(res => {
        if (res.status === 200) {
          this.mapLoading = false
          this.monitorList = res.data.data.list
          // 显示点位
          this.monitorList.forEach(item => {
            let icon = new BMapGL.Icon(require('./image/jiankonglan.png'), new BMapGL.Size(20, 25));
            let huiIcon = new BMapGL.Icon(require('./image/jiankonghui.png'), new BMapGL.Size(20, 25));
            let point = new BMapGL.Point(parseFloat(item.longitude), parseFloat(item.latitude));  // 创建点坐标
            let marker = new BMapGL.Marker(point, {
              icon: item.streamingstatus === 'normal' ? icon : huiIcon,
              title: '事件所在监控'
            });        // 创建标注
            this.map.addOverlay(marker);                     // 将标注添加到地图中
            marker.addEventListener('click', () => {
              if (item.streamingstatus === 'abnormal') {
                this.$Message.error('该监控不在线')
                return
              }
              this.monitorModal = true
              this.currentMonitor = item
              // console.log(item)
            })
          })
        }
      })
    },
    // 显示点位
    showPoint() {
      let icon = new BMapGL.Icon(require('./image/jiankonglan.png'), new BMapGL.Size(20, 25));
      let point = new BMapGL.Point(parseFloat(this.eInfo.longitude), parseFloat(this.eInfo.latitude));  // 创建点坐标
      let marker = new BMapGL.Marker(point, {title: '事件所在监控'});        // 创建标注
      console.log('标注', point)
      marker.addEventListener('click', () => {
        this.monitorModal = true
        this.currentMonitor = this.eInfo
      })
      // this.map.addOverlay(marker);                     // 将标注添加到地图中
      let circle = new BMapGL.Circle(point, 100, {
        strokeColor: "red",
        strokeWeight: 2,
        strokeOpacity: 0.5,
        fillColor: "blue",
        fillOpacity: 0.2
      }); //创建圆
      this.map.addOverlay(circle); //增加圆
    },
    playVideo() {
      this.$nextTick(() => {
        // const url = `ws://144.123.135.25:8091/rtp/${this.item['deviceId']}_${this.item['deviceId']}.live.flv`
        this.$refs.jessibuca.play()
      })
    },
    close() {
      this.$refs.jessibuca.destroy()
    },
    fullScreen() {
      this.$refs.jessibuca.fullscreen()
    },
    goRefresh() {
      this.getMessgeInfo()
    },
    formatImgPath() {
      if (this.eInfo.eventImgPath !== null && this.eInfo.eventImgPath !== '') {
        // console.log(this.eInfo.eventImgPath)
        let paths = this.eInfo.eventImgPath.split(';')
        this.eInfo.eventImgPath = paths
        // this.eInfo.eventImgPath = paths.map(path => {
        //   return path
        // })
      }
    },
    previewPic(item) {
      this.showPic = true
      this.selectPic = item
    },
    goBack() {
      this.$router.go(-1)
      this.$store.commit('app/closePage', {
        vm: this,
        fromName: this.$route.name,
      })
    },
    showModule(item, index) {
      console.log(item)
      if (index === 1 && index === 0) return
      this.curComponent = this.compConfigList.findIndex(comp => item.disposalProcess.operate === comp.label)
      this.curStepInfo = this.stepList[index].information
      console.log(this.curStepInfo)
      if (index === 4 && this.eInfo.eventLevel === '1') {
        this.preStep = this.stepList[3].information
      }
      if (index === 3 && this.eInfo.eventLevel === '2') {
        this.preStep = this.stepList[2].information
      }
    },
    getLinks() {
      this.$Loading.start()
      let params = {
        messageId: this.eInfo.id,
        eventLevel: this.eInfo.eventLevel,
        eventSeverity: this.eInfo.eventSeverity,
        indexCode: this.eInfo.deptIndexCode
      }
      this.$http.post('/api/getLinks', params).then(res => {
        // console.log(res)
        if (res.status === 200) {
          this.$Loading.finish()
          this.stepList = res.data.data
          let slist = []
          for (var s = 0; s < this.stepList.length; s++) {
            let issupport = false
            if (this.stepList[s].disposalProcess.id === '6' && this.stepList[s - 1].information !== null) {
              let info = this.stepList[s - 1].information.split(';')
              // console.log(info)
              for (var i = 0; i < info.length; i++) {
                const obj = info[i].split('_')
                if (obj[0] === 'sendingMethod') {
                  if (obj[1] === '0') {
                    issupport = true
                  }
                }
              }
            }
            if (!issupport) {
              slist.push(this.stepList[s])
            }
          }
          this.stepList = slist
          this.curStep = this.stepList.findIndex(item => Number(item.disposalProcess.id) === this.eInfo.currentLink)
          this.curComponent = this.compConfigList.findIndex(comp => this.stepList[this.curStep].disposalProcess.operate === comp.label)
          this.curStepInfo = this.stepList[this.curStep].information
          console.log('curStep', this.curStep, this.eInfo.currentLink)
          if (this.curStep === 4 && this.eInfo.eventLevel === '1') {
            this.curStepInfo = this.stepList[3].information
          }
          if (this.curStep === 3 && this.eInfo.eventLevel === '2') {
            this.curStepInfo = this.stepList[2].information
          }
        }
      }).catch(err => {
        console.log(err)
        this.$Loading.error()
      })
    },
    getMessgeInfo() {
      this.$http.get(`/api/messageReceptions/${this.eInfo.id}`).then(res => {
        console.log(res)
        this.eInfo = res.data
        this.formatImgPath()
        this.getLinks()
      })
    },
    refreshStep() {
      this.getMessgeInfo()
      // this.getLinks()
    }
  }
}
</script>

<style scoped lang="less">
#map {
  height: 600px;
  width: 100%;
  margin: 0 auto;
}

.emergency-response {
  height: 100%;
  overflow: auto;

  .el-step {
    cursor: pointer;

    :deep(.el-step__description) {
      padding: 0;
      margin-top: 0;
    }
  }
}

.content {
  width: 100%;
  height: 400px;
  position: relative;

  .video {
    position: absolute;
    width: 100%;
    height: 100%;
    //height: 15vh;
    top: 0;
    left: 0;
  }
}


</style>
